import { useMutation, useQuery } from '@tanstack/react-query'
import { useNavigation } from '@zet/common/hooks/useNavigation'
import { isApp } from '@zet/utils'
import { getName } from '@zet/utils/stringConversion'

import { getUserConsents, saveUserConsents } from './functions'

export function useGetUserConsents(
  partnerId: number,
  customerId: number,
  ipAddress: string,
  generateLinkParams: any,
  brandId: number,
  customerName: string,
  handleBottomSheet: () => void,
) {
  const navigation = useNavigation()
  return useQuery(
    ['userConsents'],
    () => getUserConsents(partnerId, customerId, ipAddress),
    {
      enabled: false,
      onSuccess: (data) => {
        if (!data?.data?.kreditBeeConsent && isApp) {
          handleBottomSheet()
          navigation?.replace('ShareCardLink', {
            generateLinkParams: generateLinkParams,
            routeName: 'missingFields',
            brandId: brandId,
            customerName: getName(customerName),
            customerId: customerId,
          })
        }
      },
    },
  )
}

export function useSaveUserConsents() {
  return useMutation(saveUserConsents)
}
